<template>
    <v-dialog persistent @input="$event == false? close() : null" :width="$vuetify.breakpoint.mdAndUp? '60%' : '90%'" :value="show">
        <v-card>
            <v-card-title>
                {{$t('Select product')}}
                <v-btn @click="close()" icon small absolute right><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text>
                <div v-if="type == 'smake'">
                    <v-btn-toggle v-model="params.category" style="flex-wrap: wrap">
                        <v-btn class="mx-1 mt-2" :outlined="name != params.category" :value="name" color="primary" :dark="name == params.category" v-for="(name) in smakeCategories"><span :class="{'white--text': params.category == name}">{{name.charAt(0).toUpperCase() + name.slice(1)}}</span></v-btn>
                    </v-btn-toggle>
                    <v-text-field v-model="params.term" class="mt-5" outlined label="Search product" append-icon="mdi-magnify"></v-text-field>
                    <v-data-table
                        :headers="headers"
                        :items="products.data"
                        :options.sync="params"
                        :expanded.sync="expanded"
                        show-select
                        :server-items-length="products.total"
                        :footer-props="{'items-per-page-options': [10, 15]}"
                    >
                        <template v-slot:item.action="{item}">
                            <v-btn depressed color="primary" small class="my-1 small-btns" @click="select(item)" dark>{{$t('Select')}}</v-btn>
                        </template>
                        <template v-slot:item.photos="{item}">
                            <v-img :src="getSrc(item.photos)" max-width="70px" max-height="700px" contain></v-img>
                        </template>
                    </v-data-table>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
import Vue from 'vue';
import {getBreads} from "../api/bread";
import {getAllProducts, getSmakeCategories} from "../api/products";


export default {
    created(){
        Vue.prototype.$selectProduct = this;
    },
    data:() => {
        return{
            selectedCategory:null,
            products:[],
            show:false,
            term:null,
            promise:{resolve:null, reject:null},
            type:null,
            categories: null,
            params: {},
            expanded: [],
            smakeCategories: []
        }
    },
    computed:{
        headers(){
            if(this.type == 'smake'){
                return [{
                    text: 'ID',
                    value: 'id',
                    sortable: true
                },{
                    text: 'Image',
                    value: 'photos',
                },{
                    text:'Name',
                    value:'name',
                    sortable:true
                },{
                    text:'Actions',
                    value:'action'
                }]
            }
        },
        website(){return this.$store.getters.activeWebsite}
    },
    mounted(){
        this.getSmakeCategories();
    },
    methods:{
        getSmakeCategories(){
            getSmakeCategories().then(res=>{
                this.smakeCategories = [];
                res.forEach(cate => {
                    if(cate.category != 'import test') this.smakeCategories.push(cate.category)
                });
            });
        },
        close(){
            this.show = false;
            this.promise.reject();
            this.$router.go(-1);
        },
        select(product){
            this.promise.resolve(product);
            this.show = false
        },
        getData(){
            if(this.type == 'normal'){
                getBreads('Product', {website_id: this.website.id, per_page: 100, select:['id', 'name', 'price', 'smake_product']}).then(response => {
                    this.products = response;
                })
            }
            if(this.type == 'smake'){
                this.getSmakeProduct();
            }
        },
        getSmakeProduct(){
            var params = {...this.params, is_active:1 , sanmar_id: null, page: this.params.page,  itemsPerPage: this.params.itemsPerPage};
            getAllProducts(params).then(res=>{
                this.products = res;
            });
        },
        selectProduct(type = 'normal'){
            return new Promise((resolve, reject) => {
                this.promise.resolve = resolve;
                this.promise.reject= reject;
                this.type = type;
                this.show = true;
                this.getData();
            })
        }
    },
    watch:{
        params: {
            deep: true,
            handler: function () {
                window.clearTimeout(this.params_timeout);
                this.params_timeout = setTimeout(() => {
                    this.getSmakeProduct();
                }, 700)
            }

        }
    }
}
</script>
